import { useAnalytics } from '../use-analytics'

/**
 * Navigates to a URL with optional tracking and tab control.
 *
 * @param {string} url - The URL to navigate to.
 * @param {Object} options - The options for the navigation.
 * @param {boolean} options.inNewTab - Whether to open the URL in a new tab.
 * @param {string} options.track - The event to track.
 *
 * @returns {void}
 */
export default (url, {
    inNewTab = false,
    track,
} = {}) => {
    const {
        trackEvent,
    } = useAnalytics()

    if (track) {
        trackEvent(track)
    }

    if (inNewTab) {
        window.open(url, '_blank')
    } else {
        window.location.href = url
    }
};